import * as React from "react";
import { MainContent } from "../MainContent";
export class MainContentWrap extends React.PureComponent {
    render() {
        const name = `${this.props.cms.ShowLivePhraseBeforeSportName
            ? this.props.dict.Live
            : ""} ${this.props.name} ${this.props.subName || ""}`;
        const eventsCount = this.props.cms.ShowSportEventsCount
            ? `(${this.props.eventsCountLength})`
            : "";
        const shouldExpand = this.props.renderedHeadings < this.props.cms.ExpandedMainGroupItems;
        const props = Object.assign(Object.assign({}, this.props), { name, eventsCount, shouldExpand });
        return (React.createElement(MainContent, Object.assign({}, props), this.props.children));
    }
}
//# sourceMappingURL=MainContentWrap.js.map